import { compact } from 'helpers/utils';

export const hasProjectName = (project) => {
  return project.name && project.name.toLowerCase() !== 'unnamed';
};

export const hasAddress1 = (project) => {
  return !!project.street_address_1;
};

export const hasCityStateZip = (project) => {
  return Boolean(project.city || project.state || project.postal_code);
};

export const addressLinesForProject = (project) => {
  let addressLine1 = '';
  let addressLine2 = '';

  if (!project) {
    return [addressLine1, addressLine2];
  }

  if (project.street_address_1 && project.name === project.street_address_1) {
    addressLine1 = project.street_address_1;
  } else {
    addressLine1 = compact([addressLine1, project.street_address_1]).join(' ');
  }

  if (project.street_address_2) {
    addressLine1 = [addressLine1, project.street_address_2].join(', ');
  }

  if (project.city) {
    addressLine2 = project.city;
  }

  if (project.state) {
    addressLine2 = [addressLine2, project.state].join(', ');
  }

  if (project.postal_code) {
    addressLine2 = [addressLine2, project.postal_code].join(' ');
  }

  return [addressLine1, addressLine2];
};

export const googleMapsUrlForProject = (project) => {
  const address = addressLinesForProject(project);

  const { lat, lon } = project.coordinates;
  const coords = `${lat.toFixed(6)}, ${lon.toFixed(6)}`;

  return project.subtitle !== ''
    ? `https://www.google.com/maps/place/${encodeURIComponent(address)}`
    : `https://www.google.com/maps/place/${encodeURIComponent(coords)}`;
};

export const titleForProject = (project) => {
  if (!project) {
    return '';
  }

  if (hasProjectName(project)) {
    return project.name;
  }

  const addressLine1 = project.street_address_1;
  const addressLine2 = project.street_address_2;
  return compact([addressLine1, addressLine2]).join(' • ');
};

export const subtitleForProject = (project) => {
  if (!project) {
    return '';
  }

  if (hasProjectName(project)) {
    const addressLine1 = project.street_address_1;
    const addressLine2 = project.street_address_2;
    const cityState = compact([project.city, project.state]).join(', ');
    return compact([addressLine1, addressLine2, cityState]).join(' • ');
  } else {
    return compact([project.city, project.state]).join(', ');
  }
};

export const projectLastUpdated = (project) => {
  return project.updated_at;
};

export const displayNameForGridImage = (project) => {
  let displayName = titleForProject(project);

  if (project.city || project.state) {
    const cityState = compact([project.city, project.state]).join(', ');
    displayName = compact([displayName, cityState]).join(' • ');
  }

  return displayName;
};

export const googleMapsCoordinates = ({ coordinates }) => ({
  lat: coordinates.lat,
  lng: coordinates.lon,
});
